import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { authInterceptor } from 'app/core/auth/auth.interceptor';
import { SessionKeeper } from 'app/core/auth/session-keeper.service';
import { viewClientInterceptor } from 'app/core/panel/view-client.interceptor';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
    return [
        provideHttpClient(withInterceptors([authInterceptor, viewClientInterceptor])),
        // Przed pierwszą nawigacją: koniec sesji bez „Zapamiętaj mnie” po zamknięciu kart i po 30 min bezczynności
        provideAppInitializer(() => inject(SessionKeeper).init()),
    ];
};
